import React from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import useDynamicDashboard from "../index";
import SettingsModalFastFilters from "./Settings/SettingsModalFastFilters";
import { Icon } from "@material-ui/core";

type ActionsMenuList = "fastFilterSettings" | "updateAfterSearch";

interface IProps {
    anchorEl: any;
    setAnchorEl: any;
    t: any;
}

const FastFiltersActionsMenu = (props: IProps) => {
    const { anchorEl, setAnchorEl, t } = props;
    const [listData, listDispatch] = useDynamicDashboard();
    const isReport =
        listData?.definitionInfo?.elasticDefData?.data?.otherSettings
            ?.isReport === true;

    const { localInfo } = listData;
    const [fastFilterSettingsOpen, setFastFiltersSettingsOpen] = React.useState(
        false
    );

    const { setFilters } = listDispatch;

    const menuOptions: ActionsMenuList[] = ["fastFilterSettings"];
    // if (!isReport) {
    //     menuOptions.push("updateAfterSearch");
    // }
    const options = orderMenuOptions(menuOptions, t);
    const handleClose = () => {
        setAnchorEl(null);
    };

    const clickMenuItem = (action: ActionsMenuList) => {
        switch (action) {
            case "fastFilterSettings":
                setFastFiltersSettingsOpen(true);
                handleClose();
                break;
            default:
                break;
        }
    };

    return (
        <div>
            <Menu
                id="sort-elastic-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                getContentAnchorEl={null}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "left"
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right"
                }}
            >
                {options.map((option: any) => {
                    return (
                        <MenuItem
                            key={option.value}
                            onClick={() => clickMenuItem(option.value)}
                        >
                            {option.label}
                        </MenuItem>
                    );
                })}
            </Menu>
            <SettingsModalFastFilters
                onClose={() => setFastFiltersSettingsOpen(false)}
                open={fastFilterSettingsOpen}
            />
        </div>
    );
};

const orderMenuOptions = (menuItems: ActionsMenuList[], t: any) => {
    const translatedNames = menuItems.map((item) => {
        return {
            label: t(`ELASTICLISTSETTINGS:FastFilterMenu_${item}`),
            value: item
        };
    });
    translatedNames.sort((a: any, b: any) => a.label.localeCompare(b.label));
    return translatedNames;
};

export default FastFiltersActionsMenu;
